import { render, staticRenderFns } from "./BooksCard.vue?vue&type=template&id=548102a7&"
import script from "./BooksCard.vue?vue&type=script&lang=js&"
export * from "./BooksCard.vue?vue&type=script&lang=js&"
import style0 from "./BooksCard.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports